import { render, staticRenderFns } from "./TheTopbarProjectMenu.vue?vue&type=template&id=16683c46&"
import script from "./TheTopbarProjectMenu.vue?vue&type=script&lang=js&"
export * from "./TheTopbarProjectMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports